<div
  class="diwali-attention card p-4 rounded-lg"
  *ngIf="recentItem && recentItem.length > 0"
  lazyLoad
  (visible)="showCaughtProduct = true"
>
  <!-- Diya symbol, defined once and reused -->
  <svg width="0" height="0" style="position: absolute" aria-hidden="true">
    <defs>
      <symbol id="diya-lamp" viewBox="0 0 64 56">
        <!-- flame -->
        <g class="diya-flame">
          <path
            d="M32 2 C39 11 41 18 32 27 C23 18 25 11 32 2Z"
            fill="#eab83e"
          />
          <path
            d="M32 11 C35 16 36 19 32 24 C28 19 29 16 32 11Z"
            fill="#fff1be"
          />
        </g>
        <!-- lamp bowl -->
        <path d="M4 32 Q32 62 60 32 Q32 38 4 32Z" fill="#79273a" />
        <path d="M4 32 Q32 38 60 32 Q32 28 4 32Z" fill="#eab83e" />
        <!-- gold rim line -->
        <path
          d="M14 38 Q32 50 50 38"
          fill="none"
          stroke="#ffe4a2"
          stroke-width="2"
          stroke-linecap="round"
        />
      </symbol>
    </defs>
  </svg>

  <!-- Heading with diyas -->
  <div class="diwali-attention-heading">
    <svg class="diya-icon"><use href="#diya-lamp"></use></svg>
    <h1 class="diwali-attention-title">These Caught Your Attention</h1>
    <svg class="diya-icon"><use href="#diya-lamp"></use></svg>
  </div>

  <!-- Gold divider -->
  <div class="diwali-divider"><span></span></div>

  <div class="relative mt-4" *ngIf="showCaughtProduct">
    <!-- Left Scroll Button -->
    <button
      *ngIf="recentItem"
      (click)="scrollLeft()"
      class="diwali-scroll-btn absolute left-2 top-1/2 transform -translate-y-1/2 z-10 p-2 rounded-full shadow-md"
      aria-label="Scroll left"
    >
      <svg viewBox="0 0 32 32" fill="currentColor" class="w-6 h-6">
        <path
          d="M23.505 0c0.271 0 0.549 0.107 0.757 0.316 0.417 0.417 0.417 1.098 0 1.515l-14.258 14.264 14.050 14.050c0.417 0.417 0.417 1.098 0 1.515s-1.098 0.417-1.515 0l-14.807-14.807c-0.417-0.417-0.417-1.098 0-1.515l15.015-15.022c0.208-0.208 0.486-0.316 0.757-0.316z"
        />
      </svg>
    </button>

    <!-- Scrollable Product List -->
    <div
      #scrollContainer
      class="diwali-scroll-area flex overflow-x-auto gap-4 px-2 sm:px-4 scroll-smooth snap-x snap-mandatory"
      style="scrollbar-width: none; -ms-overflow-style: none"
    >
      <app-product
        *ngFor="let recentView of recentItem"
        [product]="recentView"
        class="diwali-product-wrap inline-block snap-start w-52 sm:w-48 md:w-56 lg:w-64 xl:w-72 flex-shrink-0 cursor-pointer"
      ></app-product>
    </div>

    <!-- Right Scroll Button -->
    <button
      *ngIf="recentItem"
      (click)="scrollRight()"
      class="diwali-scroll-btn absolute right-2 top-1/2 transform -translate-y-1/2 z-10 p-2 rounded-full shadow-md"
      aria-label="Scroll right"
    >
      <svg
        viewBox="0 0 32 32"
        fill="currentColor"
        class="w-6 h-6 transform rotate-180"
      >
        <path
          d="M23.505 0c0.271 0 0.549 0.107 0.757 0.316 0.417 0.417 0.417 1.098 0 1.515l-14.258 14.264 14.050 14.050c0.417 0.417 0.417 1.098 0 1.515s-1.098 0.417-1.515 0l-14.807-14.807c-0.417-0.417-0.417-1.098 0-1.515l15.015-15.022c0.208-0.208 0.486-0.316 0.757-0.316z"
        />
      </svg>
    </button>
  </div>
</div>
